module.exports = __webpack_public_path__ + "img/1.721c88ac.png";